
import {
  CompoundProductionStepAssignmentDto,
  CreateCompoundProductionStepAssignmentDto,
  UpdateCompoundProductionStepAssignmentDto,
} from './dtos'
import { BaseCrudService } from './BaseCrudService'
import { PaginatedQueryBase } from './api'

export type CompoundProductionStepAssignmentsFilters = PaginatedQueryBase & {
  includeInactive?: boolean
  compoundId?: string
}

class CompoundProductionStepAssignmentService extends BaseCrudService<
  CompoundProductionStepAssignmentDto,
  CreateCompoundProductionStepAssignmentDto,
  UpdateCompoundProductionStepAssignmentDto,
  CompoundProductionStepAssignmentsFilters
> {
  constructor() {
    super('compound-production-step-assignment', process.env.REACT_APP_RADIOPHARMACY_API_URL)
  }
}

export const compoundProductionStepAssignmentService = new CompoundProductionStepAssignmentService()
